export enum WsErrorsEnum {
  INVALID_CHAT_ACCESS = 1,
  REDE_B2B_UNAVAILABLE = 2,
  USER_IS_NOT_IN_CHAT_ROOM = 3,
  MISSING_AUTH_TOKEN = 4,
  INVALID_AUTH_TOKEN = 5,
  TOO_MANY_REQUESTS = 6,
  INVALID_PAYLOAD = 7,
}
